import { useEffect, useState } from "react";
import { Layout, SectionTitle } from "@/components/Layout";
import { api } from "@/lib/api";
import { PlayCircle, X } from "lucide-react";
import { Seo } from "@/components/Seo";

const CATS = ["Todos", "Smart TV", "Android", "TV Box", "Celular", "Computador"];

export default function VideosPage() {
  const [videos, setVideos] = useState([]);
  const [cat, setCat] = useState("Todos");
  const [active, setActive] = useState(null);
  useEffect(() => { api.get("/videos").then((r) => setVideos(r.data)); }, []);
  const filtered = cat === "Todos" ? videos : videos.filter((v) => v.category === cat);

  return (
    <Layout>
      <Seo title="Vídeos de Configuração" description="Assista aos passo a passo em vídeo, organizados por tipo de dispositivo." path="/videos" />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14">
        <SectionTitle label="Vídeos" title="Vídeos de Configuração"
          subtitle="Assista aos passo a passo em vídeo, organizados por tipo de dispositivo." />
        <div className="flex flex-wrap gap-2 mb-8">
          {CATS.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`video-filter-${c.toLowerCase()}`}
              className={`px-4 py-2 rounded-full text-sm font-medium border transition ${
                cat === c ? "bg-cyan-400/15 text-cyan-300 border-cyan-400/40" : "bg-white/5 text-gray-300 border-white/10 hover:bg-white/10"}`}>
              {c}
            </button>
          ))}
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((v) => (
            <button key={v.id} onClick={() => setActive(v)} data-testid={`video-card-${v.id}`} className="ci-card overflow-hidden text-left group">
              <div className="relative aspect-video overflow-hidden">
                <img src={v.thumbnail || `https://img.youtube.com/vi/${v.youtube_id}/hqdefault.jpg`} alt={v.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                  <PlayCircle className="w-14 h-14 text-white/90 group-hover:text-cyan-300 group-hover:scale-110 transition-all" />
                </div>
                <span className="absolute top-3 left-3 text-[11px] font-semibold px-2 py-0.5 rounded-md bg-black/60 text-cyan-300 border border-cyan-400/30">{v.category}</span>
              </div>
              <div className="p-4 font-semibold">{v.title}</div>
            </button>
          ))}
        </div>
        {filtered.length === 0 && <div className="text-gray-400 text-center py-10">Nenhum vídeo nesta categoria.</div>}
      </div>

      {active && (
        <div className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4" onClick={() => setActive(null)} data-testid="video-modal">
          <div className="w-full max-w-3xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center mb-3">
              <h3 className="font-semibold">{active.title}</h3>
              <button onClick={() => setActive(null)} data-testid="video-modal-close" className="p-2 rounded-lg bg-white/10 hover:bg-white/20"><X className="w-5 h-5" /></button>
            </div>
            <div className="aspect-video rounded-xl overflow-hidden">
              <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${active.youtube_id}?autoplay=1`}
                title={active.title} allow="autoplay; encrypted-media" allowFullScreen />
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
